import React from 'react';
import QuoteForm from './components/QuoteForm';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <QuoteForm />
    </div>
  );
}

export default App;